var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadWithCircle = function SvgDownloadWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2fa8ff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.27907)",
    d: "m194.73 107.5c0-48.179-39.053-87.232-87.232-87.232s-87.232 39.053-87.232 87.232 39.053 87.232 87.232 87.232 87.232-39.053 87.232-87.232z",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.27907)",
    d: "m82.263 119.8v3.1914c0 5.305 4.2972 9.6022 9.6022 9.6022h31.998c5.305 0 9.6022-4.2972 9.6022-9.6022v-3.1914m-12.808-12.808-12.794 12.808m0 0-12.808-12.808m12.808 12.808v-38.409",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
};
export default SvgDownloadWithCircle;